<template>
  <div class="modules">
    <div class="modules-list">
      <DefaultCard
        v-for="(item, i) in modules"
        :key="i"
        :image-path="item.img"
        :card-text="item.name"
        modules
        @click-card="goToEdit(item.slug, item.isModal)"
      />
    </div>
  </div>
</template>

<script>
import DefaultCard from '@/components/blocks/DefaultCard'

import router from '@/router'

export default {
  name: 'ModulesListEducation',
  components: {
    DefaultCard
  },
  props: {
  },
  setup () {
    const modules = [
      // {
      //   id: 1,
      //   name: 'Баннер',
      //   img: require('@/assets/images/png/modules-list-education/image_banner.png'),
      //   slug: 'banner-education',
      //   isModal: false
      // },
      {
        id: 2,
        name: 'Группы обучения',
        img: require('@/assets/images/png/modules-list-education/image_group_education.png'),
        slug: 'group-learning',
        isModal: false
      }
      // {
      //   id: 3,
      //   name: 'Материалы',
      //   img: require('@/assets/images/png/modules-list-education/image_materials.png'),
      //   slug: '/',
      //   isModal: false
      // },
      // {
      //   id: 4,
      //   name: 'Заявка',
      //   img: require('@/assets/images/png/modules-list-education/image_application.png'),
      //   slug: '/',
      //   isModal: false
      // },
      // {
      //   id: 5,
      //   name: 'Подвал',
      //   img: require('@/assets/images/png/modules-list/image_footer.png'),
      //   slug: '/',
      //   isModal: false
      // }
    ]

    const goToEdit = (val, modal) => {
      if (modal === false) {
        router.push(`/modules-education/editor/${val}`)
      }
    }
    return {
      modules,
      goToEdit
    }
  }
}
</script>

<style lang="scss" scoped>
.modules {
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 30px 60px;
    margin-bottom: 60px;
  }

  &-history {
    position: fixed;
    bottom: 40px;
    right: 135px;
  }
}
</style>
